import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import AdminLayout from "../layouts/AdminLayout";

export default function ProtectedRoute({ children }: { children: React.ReactNode }) {
	const { user, loading } = useAuth();

	if (loading) {
		return (
			<div className='flex min-h-screen items-center justify-center bg-gray-50 dark:bg-gray-900'>
				<div className='h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent'></div>
			</div>
		);
	}

	if (!user) {
		return <Navigate to='/admin/login' />;
	}

	return <AdminLayout>{children}</AdminLayout>;
}
